<section id="intro-software" class="section-bg-dark">
  <div class="container-fluid">
    <div class="row">
        <div _ngcontent-fac-c9="" class="col-xs-12 pl-4">
            <h2 class="text-white">OPTIMIZACIÓN DE EXPERIENCIA DIGITAL</h2>
        </div>
    </div>
  </div>
</section>
<section id="software_proyect">
  <div class="container">
    <div class="row mb-3">
      <div class="col-sm-12 col-xs-12">
        <p class="font-medium">
          Mejoramos la experiencia digital de extremo a extremo para aumentar la eficacia comercial, optimizando el recorrido del usuario y el impacto en resultados.
        </p>
      </div>
    </div>
  </div>

  <div class="container img-claim">
    <div class="row">
        <img src="assets/img/proyect_sw_engineer.webp">
    </div>
  </div>

  <div class="container">
      <div class="row justify-content-between">

        @for (card of cards; track card) {
          <div class="card col-sm-12 col-md-4 text-center p-2">

          <div class="card-body">
            <div class="border_box">
  
              <h5>{{ card.title }}</h5>
              <p>
                  {{ card.text }}
              </p>
            </div>
          </div>
        </div>
        }
      </div>
    </div>


    <div class="container">
      <div class="row justify__content-center">
        <div class="col-6 mt-10">
          <button class="btn_help" routerLink="/contacto">¿Te ayudamos?</button>
        </div>
      </div>
    </div>
</section>